import { FlexColumn, FlexRowBetween, LoaderBar, PageHeader } from 'components'
import { Form, Input } from 'semantic-ui-react'
import { GetCustomerList, GetTempleteList, useDebounce } from 'hooks'
import { TemplateListWithCheckBox } from 'page-components'
import { useEffect, useMemo, useState } from 'react'
import {
    CommonUtility,
    InspectionService,
    TemplateQuestionResponseType,
    TemplateService,
} from 'utility'
import { useNavigate } from 'react-router-dom'
import { AppPrimaryButton } from 'elements'
import { DesktopMode, MobileMode } from 'layout'

export const CreateTemplateWithAnotherTemplatesScreen = () => {
    const {
        data,
        loading,
        filter,
        pageChanged,
        totalCount,
        setData,
        filterChanged,
    } = GetTempleteList()
    const [processing, setProcessing] = useState('')
    const { data: customerList } = GetCustomerList()
    const navigate = useNavigate()
    const [newTemplete] = useState({})
    const [copyTemplates, setCopyTemplates] = useState({})
    const [templateType, setTemplateType] = useState([])
    const [search, setSearch] = useState('')
    const finalSearch = useDebounce(search, 1000)

    useEffect(() => {
        filterChanged({ SearchText: finalSearch })
    }, [finalSearch])

    const submit = async () => {
        try {
            setProcessing(true)
            const newSections = []
            Object.values(copyTemplates)
                .sort((a, b) => a.Order - b.Order)
                .forEach(ele => {
                    const multiRes = CommonUtility.groupByData(
                        ele?.TemplateResponseType?.MultipleResponse || [],
                        'GroupId',
                    )
                    const groupRes = CommonUtility.groupByData(
                        ele?.TemplateResponseType?.UserMultipleResponse || [],
                        'GroupId',
                    )
                    ele?.Sections?.forEach(ele => {
                        const sectionId = Math.random()
                        newSections.push({
                            ...ele,
                            SectionId: sectionId,
                            Order: newSections.length,
                            Questions: ele.Questions.map(item => {
                                const resp =
                                    item.QuestionType ===
                                    TemplateQuestionResponseType.Multiple
                                        ? (item.QuestionResponseId > 9
                                              ? groupRes
                                              : multiRes
                                          ).find(
                                              res =>
                                                  res.title.toString() ===
                                                  item.QuestionResponseId.toString(),
                                          )?.data
                                        : null
                                return {
                                    ...item,
                                    Id: Math.random(),
                                    SectionId: sectionId,
                                    QuestionId: undefined,
                                    TemplateId: newTemplete.Id,
                                    CustomerMultiResponses: resp,
                                }
                            }),
                        })
                    })
                })
            await TemplateService.create({
                ...newTemplete,
                TemplateAccess: 'Multiple',
                TemplateType: templateType[0].type,
                Sections: newSections,
            })
        } finally {
            navigate('/app/templates')
            setProcessing(false)
        }
    }

    const onQuestionSelect = async (item, add = true) => {
        if (newTemplete && item) {
            const newdata = {
                ...copyTemplates[item.TemplateId],
            }
            if (add) {
                newdata.Sections = newdata.Sections.map(ele => {
                    if (
                        ele.SectionId.toString() === item.SectionId.toString()
                    ) {
                        return {
                            ...ele,
                            Questions: [...ele.Questions, { ...item }],
                        }
                    }
                    return ele
                })
            } else {
                newdata.Sections = newdata.Sections.map(ele => {
                    if (
                        ele.SectionId.toString() === item.SectionId.toString()
                    ) {
                        return {
                            ...ele,
                            Questions: ele.Questions.filter(
                                qe => qe.Id !== item.Id,
                            ),
                        }
                    }
                    return ele
                })
            }
            setCopyTemplates({
                ...copyTemplates,
                [item.TemplateId]: newdata,
            })
        }
    }

    const onRemove = async item => {
        try {
            setProcessing('Processing')
            await TemplateService.removeTemplate(item.TemplateId)
            setData(data.filter(ele => ele.TemplateId !== item.TemplateId))
        } catch (error) {
            console.log(error)
        } finally {
            setProcessing('')
        }
    }

    const startInspection = async (item, list) => {
        try {
            const result = await InspectionService.copyInspection({
                TemplateId: item.TemplateId,
                customerId: list.toString(),
            })
            navigate(`inspection/${result?.AuditTemplateId}`)
        } catch (error) {
            console.log(error)
        } finally {
            setProcessing('')
        }
    }

    const removeTemplate = id => {
        setCopyTemplates({
            ...copyTemplates,
            [id]: undefined,
        })
        setTemplateType(templateType.filter(ele => ele.Id !== id))
    }

    const addTemplates = template => {
        setCopyTemplates({
            ...copyTemplates,
            [template.Id]: {
                ...template,
                Order: Object.keys(copyTemplates).length,
            },
        })
        setTemplateType([
            ...templateType,
            { Id: template.Id, type: template.TemplateType },
        ])
    }

    const sortedData = useMemo(() => {
        return (
            data?.sort((a, b) => {
                if (Object.keys(copyTemplates).length) {
                    const orderA = copyTemplates[a.Id]
                        ? copyTemplates[a.Id].Order
                        : Infinity
                    const orderB = copyTemplates[b.Id]
                        ? copyTemplates[b.Id].Order
                        : Infinity
                    return orderA - orderB
                }
                return 0
            }) || data
        )
    }, [data, copyTemplates])

    return (
        <Form>
            <MobileMode>
                <FlexColumn>
                    <PageHeader header="Create New Template From Another Templates" />
                    <div>
                        <Input
                            className=""
                            fluid
                            placeholder="Search"
                            onChange={(_, text) => setSearch(text.value)}
                        />
                        <AppPrimaryButton
                            fluid
                            className="mt-3"
                            onClick={submit}
                        >
                            Save
                        </AppPrimaryButton>
                    </div>
                </FlexColumn>
            </MobileMode>
            <DesktopMode>
                <FlexRowBetween>
                    <PageHeader header="Create New Template From Another Templates" />
                    <div>
                        <Input
                            className="me-2"
                            placeholder="Search"
                            onChange={(_, text) => setSearch(text.value)}
                        />
                        <AppPrimaryButton onClick={submit}>
                            Save
                        </AppPrimaryButton>
                    </div>
                </FlexRowBetween>
            </DesktopMode>
            {processing || loading ? (
                <LoaderBar content={processing || 'Loading'} height="100vh" />
            ) : (
                <div className="my-3">
                    <TemplateListWithCheckBox
                        data={sortedData}
                        pageChanged={pageChanged}
                        totalCount={totalCount}
                        filter={filter}
                        customerList={customerList}
                        onRemove={onRemove}
                        startInspection={startInspection}
                        onQuestionSelect={onQuestionSelect}
                        removeTemplate={removeTemplate}
                        addTemplates={addTemplates}
                        copyTemplates={copyTemplates}
                    />
                </div>
            )}
        </Form>
    )
}
